import { generateUUID } from "../helpers/utils";

class UserCSVParserService {
    constructor() {
        this._availableGroups = [];
    }

    Parse(inlineData, availableGroups = []) {
        this._availableGroups = availableGroups;
        let rows = this.GetRows(inlineData);
        return rows.map(row => this.GetRowObject(row.trim()));
    }

    GetRows(inlineData) {
        if (inlineData === undefined || inlineData === null)
            throw new Error("Pass data is null");

        let rows = [];

        if (inlineData.includes("\n\r")) {
            rows = inlineData
                .trim()
                .split("\n\r")
                .map(line => line.trim());
        }
        else {
            rows = inlineData
                .trim()
                .split("\n")
                .map(line => line.trim());
        }
        return rows;
    }



    GetRowObject(row) {
        if (row === undefined || row === null)
            return {};

        let splitedRow = row.split(',');


        return {
            id: generateUUID(),
            name: this._indexExist(splitedRow, 0) ? splitedRow[0].trim() : "",
            surname: this._indexExist(splitedRow, 1) ? splitedRow[1].trim() : "",
            selectedGroups: this._indexExist(splitedRow, 2) ? this.GetGroupsArr(splitedRow[2].trim()): [],
            email: this._indexExist(splitedRow, 3) ? splitedRow[3].trim() : "",
            phonenumber: this._indexExist(splitedRow, 4) ? splitedRow[4].trim() : "",
        }
    }

    GetGroupsArr(groups) {
        if (groups === undefined || groups === null)
            return [];

        return groups
            .split(";")
            .map(group => {
                let localGroups = this._availableGroups
                    .filter(el => el.label.toLowerCase() === group.toLowerCase());
                if (localGroups.length === 1) {
                    return localGroups[0];
                }
                else {
                    // nie znaleziono
                    return {
                        value: -1,
                        label: group,
                    }
                }
            })
    }

    _indexExist(arr, index) {
        return typeof arr[index] !== 'undefined';
    }
}

export default new UserCSVParserService();